import { motion } from 'framer-motion';
import React from 'react';
import { FontAwesomeConfigurations } from '../../../../utils/Configuration/FontAwesomeConfiguration';

interface SettingsContainerProps {
  collapsedStates;
  setCollapsedStates;
  containerRef;
  onBlur;
}
const SettingsContainer: React.FC<SettingsContainerProps> = ({ ...props }) => {
  let shouldShowSettings = true;
  switch (CrowdHub_App.CONFIG.HIDE_MOBILE_PROFILE_DROPDOWN_SETTINGS) {
    case true:
      if (App.CORDOVA) {
        shouldShowSettings = false;
      }
      break;
    case false:
      break;
  }
  const handleOnCollapse = position => {
    const updatedCollapsedState = props.collapsedStates.map((item, index) => (index === position ? !item : item));
    props.setCollapsedStates(updatedCollapsedState);
  };
  return (
    <div className={`settings_container`}>
      <div className={`header ${props.collapsedStates[2] ? 'visible' : ''}`} onClick={e => handleOnCollapse(2)}>
        Settings
        <i className={`collapse_icon ${FontAwesomeConfigurations.ICON_MINUS} fa-fw`} />
        <i className={`expand_icon ${FontAwesomeConfigurations.ICON_CHEVRON_DOWN} fa-fw`} />
      </div>
      <motion.div
        className="dropdown_items_container"
        variants={dropdown}
        initial={`hidden`}
        animate={props.collapsedStates[2] ? 'visible' : 'hidden'}
        style={{ y: 12 }}
        ref={props.containerRef}
      >
        {shouldShowSettings && (
          <button
            className="dropdown_item"
            onClick={e => {
              props.onBlur();
              App.INSTANCE.appDeviceManager?.showDeviceChangePanel({
                chosenTab: 'video_tab',
              });
            }}
            role="link"
            aria-label={CrowdHub_App.LANG.PROFILE_DROPDOWN_CAM_VID_SETTINGS}
            tabIndex={0}
            style={{ border: 'none' }}
          >
            <div className="icon">
              <i className={FontAwesomeConfigurations.ICON_VIDEO}></i>
            </div>
            <div className="text">{CrowdHub_App.LANG.PROFILE_DROPDOWN_CAM_VID_SETTINGS}</div>
          </button>
        )}
        <button
          className="dropdown_item"
          onClick={e => {
            props.onBlur();
            let url = App.INSTANCE.appRouter.generate('navigate.notificationpreferences');
            App.INSTANCE.route(url);
          }}
          role="link"
          aria-label={CrowdHub_App.LANG.PROFILE_DROPDOWN_NOTIFICATION_SETTINGS}
          tabIndex={0}
          style={{ border: 'none' }}
        >
          <div className="icon">
            <i className={FontAwesomeConfigurations.ICON_LIST_CHECK}></i>
          </div>
          <div className="text">{CrowdHub_App.LANG.PROFILE_DROPDOWN_NOTIFICATION_SETTINGS}</div>
        </button>
      </motion.div>
    </div>
  );
};

const dropdown = {
  hidden: {
    opacity: 0,
    transition: { duration: 0.15 },
    display: 'none',
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.15 },
    display: 'flex',
  },
};

export default SettingsContainer;
